import React from 'react';
import { Typography } from "../ecosystem";

const HealthPlanTileUsage = ({
    apiRunningSlow,
    healthPlanData
}) => {

    const hasData = healthPlanData &&
        (typeof healthPlanData.PercentageMet !== 'undefined' && healthPlanData.PercentageMet !== null && healthPlanData.PercentageMet !== '') &&
        (typeof healthPlanData.CurrentTotal !== 'undefined' && healthPlanData.CurrentTotal !== null && healthPlanData.CurrentTotal !== '');

    return (<div className={`health-plan-tile-usage`}>
        {apiRunningSlow
            ? <div className="health-plan-tile-usage__message">
                <Typography type="body-02">
                    We're sorry, it's taking a while to load.
                </Typography>
            </div>
            : <>
                {hasData
                    ? <div className="health-plan-tile-usage__chart">
                        <Typography type="body-01" tag="h3">
                            {healthPlanData.DisplayName}
                        </Typography>
                        <ProgressBar percentage={{ amountDeci: healthPlanData.PercentageMet, maxAmountDeci: 100 }} />
                        <span className="amt-available"><Typography type="body-02" color="$color-system-a1" bold>${healthPlanData.CurrentTotal}</Typography></span>
                        <span className="amt-max"><Typography type="body-02">${healthPlanData.Maximum}</Typography></span>
                    </div>
                    :
                    <div className="health-plan-tile-usage__message">
                        <Typography type="body-02">No information available.</Typography>
                    </div>
                }
            </>
        }
    </div>);
}

const ProgressBar = (props) => {
    return (
        <div className="progress-bar">
            <Filler percentage={props.percentage} key={props.i} />
        </div>
    );
};

const Filler = (props) => {
    return <div className="filler" style={{ width: `${(props.percentage.amountDeci / props.percentage.maxAmountDeci) * 100}%` }} />
};

export default HealthPlanTileUsage;
